import { sha1 } from 'sha.js';

const chunk_size = 64 * 1024;

export async function calculateSHA1(
  file: File,
  onProgress: ((progress_percent: number) => void) | null,
): Promise<string> {
  const hash = new sha1(); // Initialize SHA1 hasher
  let offset = 0;

  // Process each chunk of the file
  const process_chunk = async (chunk: Blob): Promise<void> => {
    const reader = new FileReader();
    return new Promise((resolve, reject) => {
      reader.onload = (event: ProgressEvent<FileReader>) => {
        if (event.target?.result instanceof ArrayBuffer) {
          const result = event.target?.result;
          const chunkArray = new Uint8Array(result);
          hash.update(chunkArray);
          resolve();
        } else {
          reject(new Error('target is not an ArrayBuffer'));
        }
      };
      reader.onerror = reject;
      reader.readAsArrayBuffer(chunk);
    });
  };

  // Process file in chunks
  while (offset < file.size) {
    const chunk = file.slice(offset, offset + chunk_size);
    await process_chunk(chunk);
    offset += chunk_size;
    if (onProgress) {
      //only call this every 10 chunks cause it seems unneccassary to have super granular updates
      onProgress((offset / file.size) * 100);
    }
  }

  // Finalize and get the hash as a hex string
  const hashHex = hash.digest('hex');
  return hashHex;
}
